import type { TranslationMessages } from '../../types';

export const badges: TranslationMessages = {
  title: 'Badges',
  subtitle: 'View your achievement badges and rewards',
  earned_badges: 'Earned Badges',
  all_badges: 'All Badges',
  badge_categories: 'Badge Categories',
  attendance: 'Attendance',
  performance: 'Performance',
  teamwork: 'Teamwork',
  special: 'Special',
  customer_service: 'Customer Service',
  badge_rarity: 'Badge Rarity',
  common: 'Common',
  uncommon: 'Uncommon',
  rare: 'Rare',
  epic: 'Epic',
  legendary: 'Legendary',
  badge_details: 'Badge Details',
  badge_criteria: 'Badge Criteria',
  point_reward: 'Point Reward',
  earned_at: 'Earned At',
  awarded_by: 'Awarded By',
  no_badges_earned: 'No badges earned yet',
  filter_by_category: 'Filter by Category',
  filter_by_rarity: 'Filter by Rarity',
  apply_filter: 'Apply Filter',
  stats_total_badges: 'Total Badges',
  stats_available_badges: 'Available badges',
  stats_active_badges: 'Active Badges',
  stats_currently_active: 'Currently active',
  stats_legendary_badges: 'Legendary Badges',
  stats_highest_rarity: 'Highest rarity',
  stats_avg_points: 'Avg. Points Required',
  stats_points_to_earn: 'Points to earn',
  filters_title: 'Filters',
  search_label: 'Search',
  search_placeholder: 'Search badges...',
  category_label: 'Category',
  all_categories: 'All Categories',
  rarity_label: 'Rarity',
  all_rarities: 'All Rarities',
  staff_badges_title: 'Staff Badges',
  items_count: '%{count} items',
  no_badges_found: 'No badges found',
  no_badges_matching: 'No badges found matching your criteria',
  failed_load: 'Failed to load badges',
  delete_success: 'Badge deleted successfully',
  delete_failed: 'Failed to delete badge',
  points_label: 'pts',
};
